import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  DocumentTypeOptions,
  DocumentType,
} from 'src/app/enum/document-type.enum';

import { nifValidator } from 'src/app/utils/validators/nif.validator';
import { nieValidator } from 'src/app/utils/validators/nie.validator';
import { rutValidator } from 'src/app/utils/validators/rut.validator';
import { passportValidator } from 'src/app/utils/validators/passport.validator';

@Component({
  selector: 'app-document-type-input',
  templateUrl: './document-type-input.component.html',
  styleUrls: ['./document-type-input.component.css'],
})
export class DocumentTypeInputComponent implements OnInit, OnDestroy {
  @Input() formGroup!: FormGroup;
  @Input() typeControlName!: string;
  @Input() numberControlName!: string;
  @Input() labelPrefix = 'modals.add_personal';

  documentTypes = DocumentTypeOptions;
  docTypeEnum = DocumentType;

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    const typeCtrl = this.getTypeCtrl();
    const numCtrl = this.getNumberCtrl();

    if (!typeCtrl || !numCtrl) {
      return;
    }

    typeCtrl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((type: DocumentType) => {
        this.applyValidators(type);
      });

    this.applyValidators(typeCtrl.value);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private applyValidators(type: DocumentType): void {
    const numCtrl = this.getNumberCtrl();
    if (!numCtrl) {
      return;
    }

    let validators = [];

    switch (type) {
      case DocumentType.NIF:
        validators = [
          Validators.required,
          nifValidator,
          Validators.maxLength(9),
        ];
        break;

      case DocumentType.NIE:
        validators = [
          Validators.required,
          nieValidator,
          Validators.maxLength(9),
        ];
        break;

      case DocumentType.Passport:
        validators = [
          Validators.required,
          passportValidator,
          Validators.maxLength(9),
        ];
        break;

      case DocumentType.RUT:
        validators = [
          Validators.required,
          rutValidator,
          Validators.maxLength(10),
        ];
        break;

      default:
        numCtrl.clearValidators();
        numCtrl.updateValueAndValidity();
        return;
    }

    numCtrl.setValidators(validators);
    numCtrl.updateValueAndValidity();
  }

  limitLength(e: Event) {
   const v = (e.target as HTMLInputElement).value || '';
   if (v.length > 32) {
     (e.target as HTMLInputElement).value = v.slice(0, 32);
     this.formGroup
       .get(this.numberControlName)
       ?.setValue(v.slice(0, 32), { emitEvent: false });
   }
 }

  private getTypeCtrl(): AbstractControl | null {
    return this.formGroup?.get(this.typeControlName) ?? null;
  }

  private getNumberCtrl(): AbstractControl | null {
    return this.formGroup?.get(this.numberControlName) ?? null;
  }

}